var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagesTopbarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.97 27.94C21.6854 27.94 27.94 21.6854 27.94 13.97C27.94 6.25457 21.6854 0 13.97 0C6.25458 0 0 6.25457 0 13.97C0 21.6854 6.25458 27.94 13.97 27.94Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 10.0382C7.46875 9.6029 7.82165 9.25 8.25698 9.25H19.6885C20.1238 9.25 20.4767 9.6029 20.4767 10.0382V16.8241C20.4767 17.2594 20.1238 17.6123 19.6885 17.6123H13.9727L10.2562 20.8643V17.6123H8.25697C7.82165 17.6123 7.46875 17.2594 7.46875 16.8241V10.0382Z",
    fill: "#FFF057",
    stroke: "#FFF057",
    strokeWidth: 0.394113,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesTopbarIcon);
export default __webpack_public_path__ + "static/media/messages-topbar-icon.0d853a73aa0c92e56cbefe49c1c1d3e7.svg";
export { ForwardRef as ReactComponent };